import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventName,
  GATrackingEventType,
} from '../../constants';

export class GaTrackingLoadbeeButtonViewEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.LoadBeeButtonView;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.LoadBeeView,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category,
      },
    };
  }
}
